import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import Rule from './rule';
import Title from '../../baseComponents/Title';
import { getNeededTokensToRoll } from '../../../redux/Rules/selectors';

const RuleContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  flex-wrap: wrap;
  padding-left: 1em;
  max-height: 220px;
`;
const MainContainer = styled.div`
  display: flex;
  flex: 2;
  flex-direction: column;
  flex-wrap: no-wrap;
`;

const RulesContainer = () => {
  const {
    settings: { rules },
    user: { tokens },
  } = useSelector((state) => state);
  const rollCost = useSelector((state) => getNeededTokensToRoll(state));
  const Rules = rules.map((rule) => {
    return <Rule key={rule.id} canRoll={rollCost <= tokens} rule={rule} />;
  });

  return (
    <MainContainer>
      <Title text="Rules" />
      <RuleContainer>{Rules}</RuleContainer>
    </MainContainer>
  );
};

export default RulesContainer;
